<template>
	<div v-editable="blok">
		<NuxtLink
			v-if="link"
			:to="link"
			class="transition-colors duration-300 ease-linear hover:text-blue-dark"
		>
			<StoryblokTextField :value="blok.text" />
		</NuxtLink>
		<p v-else-if="typeof blok.text === 'string'">
			{{ blok.text }}
		</p>
		<!-- An empty field arrives as undefined, which StoryblokRichText throws on. -->
		<StoryblokRichText v-else-if="blok.text" :doc="blok.text" />
	</div>
</template>

<script setup lang="ts">
import type { BlokText } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokText;
}
const { blok } = defineProps<Props>();

const link = computed(() =>
	blok.Link.linktype === "story" && blok.Link.url ? `/${blok.Link.url}` : null
);
</script>
